/**
 * @fileoverview Hook for responsive layout values
 */
import { useMantineTheme, useMediaQuery } from 'hooks'
import { SPACING } from './styles'

interface ResponsiveValues {
  isMobile: boolean
  isLargeScreen: boolean
  modalPadding: number
  studentListHeight: number
  modalSize: number | string
}

export const useResponsive = (): ResponsiveValues => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`) ?? false
  const isLargeScreen = useMediaQuery(`(min-width: ${theme.breakpoints.lg})`) ?? false

  const modalPadding = isMobile ? SPACING.modalMobile : SPACING.modal
  const studentListHeight = isMobile ? 280 : isLargeScreen ? 420 : 340
  const modalSize = isMobile ? '100%' : isLargeScreen ? 900 : 800

  return { isMobile, isLargeScreen, modalPadding, studentListHeight, modalSize }
}
